import { useMemo } from 'react';

import { useClusters } from '@cast/shared-cluster-context-data-access';
import {
  ClusterDisplayStatus,
  WorkloadOptimizationAgentStatus,
} from '@cast/types';

import { useSecurityInsightsAgents } from 'hooks/queries/security-insights';
import { useWorkloadOrganizationAgentStatuses } from 'hooks/queries/workload-optimization';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { ClusterListEntity } from '../features/dashboard/types';

export const useGetOrganizationClusterFeaturesAccess = () => {
  const { currentOrganization } = useOrganizations();
  const { clusters } = useClusters();
  const clusterIds = useMemo(() => clusters.map((c) => c.id), [clusters]);

  const { agentsData } = useSecurityInsightsAgents({
    clusterIds,
    enabled: !!clusterIds.length,
  });
  const { data: woopStatuses } = useWorkloadOrganizationAgentStatuses({
    organizationId: currentOrganization?.id || '',
  });

  const getOrganizationClusterFeatures = (cluster: ClusterListEntity) => {
    return {
      isDiscovered: cluster.status === ClusterDisplayStatus.DISCOVERED,
      isCostMonitoringEnabled: true,
      isSecurityAgentEnabled: Boolean(
        agentsData?.statuses?.[cluster.id]?.installed
      ),
      isAutoscalerEnabled: cluster.isManaged,
      isWoopEnabled:
        woopStatuses?.find(({ clusterId }) => clusterId === cluster.id)
          ?.status === WorkloadOptimizationAgentStatus.RUNNING,
    };
  };

  return {
    getOrganizationClusterFeatures,
  };
};
